import './index.scss'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import { combineReducers, createStore } from 'redux'
import './index.scss'
import userGroupReducer from './redux/reducers/userGroup'
import Insurance from './redux/reducers/Insurance'
const appReducer = combineReducers({
    userGroup: userGroupReducer,
    Insurance:Insurance
  })
  const store = createStore(appReducer)
ReactDOM.render(<Provider store={store} ><App /></Provider>
    , document.getElementById('root'))
